import React from "react";

import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { InclusionAgentPatientAccepted } from "@/models/InclusionAgentModel.ts";
import { TextToast } from "@/uiKit/atoms/Toast.tsx";
import { PatientAcceptedTelemonitoringCard } from "@/uiKit/molecules/InclusionCenter/PatientAcceptedTelemonitoringCard.tsx";
import { PatientCreation } from "@/uiKit/organisms/PatientCreationAndRenewal/PatientCreation.tsx";

export type InclusionAgentAcceptedSuggestionProps = {
  suggestion: InclusionAgentPatientAccepted;
  className?: string;
};

export const InclusionAgentAcceptedSuggestion: React.FC<InclusionAgentAcceptedSuggestionProps> = ({
  suggestion,
  className,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isPatientCreationOpened, setPatientCreationOpened] = React.useState(false);

  return (
    <>
      <PatientAcceptedTelemonitoringCard
        patientFirstName={suggestion.firstName}
        patientLastName={suggestion.lastName}
        patientId={suggestion.id}
        onStartTelemonitoring={() => setPatientCreationOpened(true)}
        className={className}
      />
      <PatientCreation
        id="patient-creation-from-inclusion-agent"
        open={isPatientCreationOpened}
        defaultValues={{
          givenName: suggestion.firstName,
          familyName: suggestion.lastName,
          email: suggestion.email,
          phone: suggestion.phoneNumber,
        }}
        inclusionAgent={suggestion}
        onClose={() => setPatientCreationOpened(false)}
        onSubmit={(patientId: string) => {
          setPatientCreationOpened(false);
          TextToast.success(t("diabetesForms.patientCreated"), t("diabetesForms.clickToView"), {
            onClick: () =>
              navigate({
                to: `/patients/${patientId}`,
              }),
          });
        }}
      />
    </>
  );
};
